import { combineReducers } from "redux";
import ManageSite from "./manage-site";
import AdvertiseWithUsReducer from './advertise-with-us';
const reducers = combineReducers({
  ManageSite,
  AdvertiseWithUsReducer
});

export default reducers;
